import * as React from "react";
import { Context } from "./_context";
export const IrsPrepaidIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 21H4v-2h16v2ZM8.5 17.5h-2v-11h2v11Zm4.5 0h-2v-11h2v11Zm10.242-5.83-4.967 5.5a1 1 0 0 1-1.432.054l-.073-.079-2.534-3 1.528-1.29 1.794 2.124 4.2-4.649 1.484 1.34ZM17.5 11h-2V6.5h2V11ZM20 5H4V3h16v2Z", fill: "currentColor" }));
  return iconset[size];
};
IrsPrepaidIcon.iconId = "xtPPv9";
